// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#form-container {
  position: absolute;
  top: 5%;
  left: 50%;
  transform: translateX(-50%);
  width: 80%;
  max-width: 1024px;
  height: 75%;
  display: none;
  background-color: white;
  z-index: 1000005;
}

#form-pdf {
  position: absolute;
  width: 100%;
  height: 100%;
  display: none;
  z-index: 1000005;
}

#form-md {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: auto;
  display: none;
  z-index: 1000005;
}

#form-input {
  position: absolute;
  top: 105%;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  width: 100%;
  height: max-content;
  display: none;
  z-index: 0;
}

.form-input-btn {
  font-size: 1.2rem;
  margin: 0 0.5rem;
  width: 5rem;
  height: 3rem !important;
  outline: none;
  border: none !important;
  border-radius: 7px !important;
  font-weight: 700 !important;
  background-color: #ddd !important;
}

.form-input-btn:hover {
  outline: 2px solid #999 !important;
  outline-offset: 0.2rem !important;
}

.form-input-btn:active {
  outline: 2px solid #999 !important;
  outline-offset: 0.2rem !important;
  background-color: #bbb !important;
}

/* -------------------------------------------------------------------------- */

#exp-end-text {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100vh;
  background-color: white;
  font-size: 1rem;
  display: grid;
  line-height: 100vh;
  vertical-align: middle;
  grid-template-columns: auto;
  justify-content: space-around;
  visibility: hidden;
  z-index: 10000;
  user-select: none;
}
`, "",{"version":3,"sources":["webpack://./components/css/forms.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,6BAA6B;EAC7B,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;EAClC,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA,+EAA+E;;AAE/E;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;EAC3B,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB","sourcesContent":["#form-container {\n  position: absolute;\n  top: 5%;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 80%;\n  max-width: 1024px;\n  height: 75%;\n  display: none;\n  background-color: white;\n  z-index: 1000005;\n}\n\n#form-pdf {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: none;\n  z-index: 1000005;\n}\n\n#form-md {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  display: none;\n  z-index: 1000005;\n}\n\n#form-input {\n  position: absolute;\n  top: 105%;\n  left: 50%;\n  transform: translateX(-50%);\n  text-align: center;\n  width: 100%;\n  height: max-content;\n  display: none;\n  z-index: 0;\n}\n\n.form-input-btn {\n  font-size: 1.2rem;\n  margin: 0 0.5rem;\n  width: 5rem;\n  height: 3rem !important;\n  outline: none;\n  border: none !important;\n  border-radius: 7px !important;\n  font-weight: 700 !important;\n  background-color: #ddd !important;\n}\n\n.form-input-btn:hover {\n  outline: 2px solid #999 !important;\n  outline-offset: 0.2rem !important;\n}\n\n.form-input-btn:active {\n  outline: 2px solid #999 !important;\n  outline-offset: 0.2rem !important;\n  background-color: #bbb !important;\n}\n\n/* -------------------------------------------------------------------------- */\n\n#exp-end-text {\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100vh;\n  background-color: white;\n  font-size: 1rem;\n  display: grid;\n  line-height: 100vh;\n  vertical-align: middle;\n  grid-template-columns: auto;\n  justify-content: space-around;\n  visibility: hidden;\n  z-index: 10000;\n  user-select: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
